import { useCallback, useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import AdminFiles from "./AdminFiles";
import AdminUsers from "./AdminUsers";
import AdminChat from "./AdminChat";
import AdminRewards from "./AdminRewards";
import AdminSupport from "./AdminSupport";
import AdminCoins from "./AdminCoins";
import AdminBilling from "./AdminBilling";

const STATS = [["users", "Пользователи"], ["pending", "Файлы на проверке"], ["approved", "Одобрено файлов"], ["open_tickets", "Открытые обращения"], ["messages", "Сообщений в чате"]];

export default function AdminPage() {
  const { user } = useAuth();
  const admin = user.role === "admin";
  const [stats, setStats] = useState({});
  const loadStats = useCallback(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);
  useEffect(() => { loadStats(); }, [loadStats]);

  const tabs = [
    ["files", "Файлы", <AdminFiles onChange={loadStats} />, true],
    ["users", "Пользователи", <AdminUsers onChange={loadStats} />, admin],
    ["coins", "Коины", <AdminCoins />, true],
    ["chat", "Чат", <AdminChat />, true],
    ["rewards", "Награды", <AdminRewards />, admin],
    ["billing", "Оплата", <AdminBilling />, admin],
    ["support", "Поддержка", <AdminSupport onChange={loadStats} />, true],
  ].filter((t) => t[3]);

  return (
    <div>
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#2e7d56]">{admin ? "Администратор" : "Модератор"}</p>
      <h1 className="font-display text-3xl sm:text-5xl font-extrabold text-[#0b2e20] mt-2">Панель управления</h1>
      <div className="mt-6 sm:mt-8 grid grid-cols-2 md:grid-cols-5 gap-2 sm:gap-3">
        {STATS.map(([k, l]) => (
          <div key={k} className="rounded-xl bg-white border border-[#d1e7dd] p-4">
            <div className="text-[11px] uppercase tracking-widest text-[#2e7d56] font-bold">{l}</div>
            <div className="font-display text-2xl font-extrabold text-[#0b2e20] mt-1" data-testid={`admin-stat-${k}`}>{stats[k] ?? "—"}</div>
          </div>
        ))}
      </div>
      <Tabs defaultValue="files" className="mt-8 sm:mt-10">
        <TabsList className="bg-[#e8f5ed] rounded-full p-1 h-auto w-full sm:w-auto justify-start overflow-x-auto scrollbar-thin">
          {tabs.map(([id, label]) => (
            <TabsTrigger key={id} value={id} data-testid={`admin-tab-${id}`} className="shrink-0 rounded-full px-4 py-2 data-[state=active]:bg-[#1f5f42] data-[state=active]:text-white">{label}</TabsTrigger>
          ))}
        </TabsList>
        {tabs.map(([id, , node]) => <TabsContent key={id} value={id} className="mt-6">{node}</TabsContent>)}
      </Tabs>
    </div>
  );
}
